import styled from '@emotion/styled/macro';
import vars from '../../variables';

export const NavFullWidthContainer = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 5.7rem;
  background-color: white;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
`;

export const NavDropdown = styled.div`
  font-size: 14px;
`;

export const NavContentContainer = styled.div`
  max-width: ${vars.mainMaxWidth};
  max-height: 80vh;
  overflow: auto;
  margin: 0 auto;
  padding: 0 ${vars.spacingL};

  display: grid;
  grid-template-columns: 1fr 1.5fr;
  grid-template-rows: auto;
  gap: 0;
  grid-auto-flow: row;
  grid-template-areas:
    'grid-area-1 grid-area-2'
    'grid-area-3 grid-area-3';

  @media screen and (min-width: ${vars.breakPointSmallDesktop}) {
    grid-template-columns: 0.75fr 1.25fr 1fr;
    grid-template-rows: 1fr;
    grid-template-areas: 'grid-area-1 grid-area-2 grid-area-3';
  }
`;
